
import { mapGetters } from "vuex"
import Button from "@/components/base/Button"
import {
    mdiFormatListBulletedSquare,
    mdiCloseCircleOutline,
    mdiChevronDown,
} from "@mdi/js"
export default {
    name: "LivestreamTabs",
    components: {
        Button,
        LivestreamChat: () => import("@/components/livestream/LivestreamChat"),
    },
    data() {
        return {
            mdiCloseCircleOutline,
            mdiChevronDown,
            tab: 0,
            mobileChatOpened: false,
        }
    },
    computed: {
        ...mapGetters("livestream", {
            hasPolls: "hasPolls",
            hasAgenda: "hasAgenda",
            hasAppearances: "hasAppearances",
        }),
        isMobile() {
            return this.$breakpoint.mdAndDown
        },
        showPolls() {
            return this.hasPolls || this.$can.admin()
        },
        hasNoTabs() {
            return this.tabs.length === 0
        },
        tabs() {
            const tabsArray = []
            if (this.showPolls)
                tabsArray.push({
                    name: "Abstimmungen",
                    img: require("@/assets/icons/v2.1/icon_speechbubble.svg"),
                    component: () =>
                        import("@/components/livestream/LivestreamPolls"),
                })
            if (this.hasAgenda)
                tabsArray.push({
                    name: "Agenda",
                    icon: mdiFormatListBulletedSquare,
                    component: () =>
                        import("@/components/livestream/LivestreamAgenda"),
                })
            if (this.hasAppearances) {
                tabsArray.push({
                    name: "Firmen im Stream",
                    icon: mdiFormatListBulletedSquare,
                    componentAttributes: {
                        showHeadline: false,
                    },
                    component: () =>
                        import("@/components/livestream/StreamingList"),
                })
            }
            return tabsArray
        },
    },
    created() {
        // if there are no other tabs (no polls and no ageda) then open chat
        this.mobileChatOpened = this.hasNoTabs
    },
    methods: {
        toggleMobileChat() {
            this.mobileChatOpened = !this.mobileChatOpened
        },
    },
}
